import {takeEvery, all, fork} from 'redux-saga/effects';
import {START_CREATE_SNAPSHOT, START_FETCH_SNAPSHOTS} from '../SnapshotActions';
import {createArtworkRest, fetchSnapShots} from './workers';

export function* watchFetchSnapshotsWorker() {
    yield takeEvery(START_FETCH_SNAPSHOTS, fetchSnapShots);
}

export function* watchCreateArtworkWorker() {
    yield takeEvery(START_CREATE_SNAPSHOT, createArtworkRest);
}

export default function* watchSnapshot() {
    yield all([fork(watchCreateArtworkWorker), fork(watchFetchSnapshotsWorker)]);
}
